export const GET_USEFUL_FILES           = "GET_USEFUL_FILES";
export const GET_USEFUL_FILES_FAIL      = "GET_USEFUL_FILES_FAIL";
export const GET_USEFUL_FILES_SUCCESS   = "GET_USEFUL_FILES_SUCCESS";
export const GET_FOLDERS                = "GET_FOLDERS";
export const GET_FOLDERS_SUCCESS        = "GET_FOLDERS_SUCCESS";
export const GET_FOLDERS_FAIL           = "GET_FOLDERS_FAIL";
export const CLEAN_USEFUL_FILES_STATE   = "CLEAN_USEFUL_FILES_STATE";
